// Quantitative presentation only. Keep names, dates, document identifiers,
// inputs and live hover readouts out of the entrance layer. New workspaces can
// opt a complete formatted value in with data-number-animate="true".
// A target can contain formatting spans/wbr: prefer the complete money wrapper
// over its parent, and never animate individual thousands groups separately.
export const NUMBER_MOTION_SELECTOR = [
  '[data-number-animate="true"]',
  '.dashboard-number',

  // Approved home and the retained employee/legacy dashboard presentations.
  '.dp-kpi-value',
  '.dp-kpi-details dd',
  '.dp-profit-detail b',
  '.dp-expense-share strong',
  '.dp-plan-figures dd',
  '.dp-plan-footer b',
  '.dp-gauge-value > strong',
  '.dp-health-symbol > strong',
  '.dp-health-total > strong',
  '.dp-health-counts strong',
  '.dp-task-count',
  '.dp-audit-total > strong',
  '.dp-status-grid b',
  '.dp-ledger-row > b',
  '.dashboard-kpi strong',
  '.dashboard-metric-value',
  '.expense-total',

  // Shared chart values and legends, not their scales or tick labels.
  '.donut-center > strong',
  '.distribution-total > strong',
  '.distribution-amount',
  '.distribution-share',
  '.bar-value',
  '.expense-corrections strong',
  '.expense-corrections small',

  // Analytics money wrappers deliberately retain grouped digits and ₽ together.
  '.revenue-money',
  '.checks-money',
  '.dishes-money',
  '.revenue-summary-comparison:not(.unavailable)',
  '.revenue-summary-checks dd',
  '.revenue-summary-breakdown dd',
  '.kpi-card > strong',
  '.checks-kpi-strip strong',
  '.checks-total-badge',
  '.checks-duration-row > strong',
  '.checks-control-empty > strong',
  '.checks-control-row > strong',
  '.checks-deletion-total',
  '.checks-reason-share',
  '.dishes-totals dd',
  '.dishes-leader-revenue',
  '.dishes-leader-detail > span:not([aria-hidden])',
  '.dish-quantity',
  '.dish-share',
  '.dishes-abc-filter button > span',

  // Sensor readings and state counts, not sensor names or freshness dates.
  '.temperature-number',
  '.temperature-tile-value',
  '.temperature-stat-grid strong',
  '.temperature-status-filters strong',

  // Banking, invoices, counterparties and their explicitly numeric cells.
  '.banking-kpi > strong',
  '.banking-balance-value > strong',
  '.operation-amount',
  '.banking-operation-card > header > strong',
  '.invoices-kpis strong',
  '.invoice-total > strong',
  '.invoice-detail-totals strong',
  '.invoices-table td.money > strong',
  '.bank-operation-amount',
  '.calendar-invoice-amount',
  '.cp-summary strong',
  '.cp-balance-grid strong',
  '.cp-matrix-cell > strong',
  '.supplier-document-amount',
  '.supplier-card-summary strong',
  '.supplier-registry-table td.supplier-registry-money',
  '.supplier-details-document-money',
  '.supplier-details-document-heading > strong',

  // Budget control and payment calendar. Plan buttons are complete readouts;
  // editing fields remain excluded regardless of their surrounding classes.
  '.budget-number-cell > strong',
  '.budget-value-button',
  '.budget-revenue-ring > div > strong',
  '.budget-progress-top > strong',
  '.budget-limit > strong',
  '.budget-cash-total > strong',
  '.budget-detail-document-amount',
  '.calendar-summary-content > strong',
  '.calendar-group-summary > strong',
  '.payment-calendar-modal-body > dl > div:nth-child(-n+2) > dd',

  // Labor cost, payroll and employee finance summaries.
  '.cost-total',
  '.payroll-summary strong',
  '.payroll-people-summary strong',
  '.payroll-employee-row > span:not(.payroll-person):not(.payroll-facts)',
  '.payroll-employee-row > strong',
  '.payroll-people-row-button > span:not(.payroll-person):not(.payroll-people-blocked)',
  '.payroll-people-row-button > strong',
  '.payroll-company-cost > strong',
  '.payroll-company-cost > small',
  '.payroll-people-card-open > strong',
  '.payroll-people-cards dd',
  '.calculation-lines > div > strong',
  '.payments__summary strong',
  '.personnel-expenses__summary strong',
  '.operation-totals strong',
  '.operation-row .amount',
  '.service-totals strong',
  '.service-amount > strong',
  '.adjustment-entry__amount',
  '.employee-stats__summary strong',
  '.employee-stats__lines > div > strong',
  '.employee-stats__entries > article > strong',
  '.employee-finance-summary-list dd',
  '.employee-finance-values dd',
  '.employee-finance-disclosure > summary > strong',
  '.employee-summary-grid strong',
  '.employee-metrics-grid strong',
  '.employee-kpi-table tbody td:nth-of-type(4)',
  '.employee-kpi-table tbody td:nth-of-type(5)',
  '.employee-kpi-table tbody td:last-of-type > strong',
  '.employee-mobile-card dd',
  '.employee-results strong',
  '.schedule-summary strong',
  '.day-employee-count',
  '.is-fact-total > strong',
  '.employee-week-metrics .is-fact-metric',
  '.shift-card-total',
  '.day-cost-main > strong',
  '.master-economics-grid strong',
  '.master-day-metrics dd',
  '.master-load-summary-values > strong',
  '.master-load-summary-values > small',
  '.master-role-total',
  '.master-place-cost',
  '.lc-cell-value > strong',
  '.lc-cell-share > strong',
  '.calendar-breakdown-row > strong',
  '.check-interval-totals > strong',
  '.interval-check-meta > strong',
  '.interval-check-meta > small',
  '.check-position > header b',

  // Stock, cost reporting, audits, reviews and task-board counters.
  '.inventory-metrics strong',
  '.receipt-list-cell[data-label="Сумма"] > strong',
  '.recipe-table [data-label="Себестоимость"] > strong',
  '.recipe-import-metrics dd',
  '.recipe-detail-summary strong',
  '.storehouse-summary strong',
  '.food-cost-total-primary > strong',
  '.food-cost-total-amounts dd',
  '.food-cost-department-percent',
  '.food-cost-department dd',
  '.sh-document-total > strong',
  '.stock-total > strong',
  '.stock-group-total',
  '.stock-quantity',
  '.stock-value',
  '.audit-metric-strip strong',
  '.audit-summary-total > strong',
  '.audit-severity-options strong',
  '.audit-list-findings > strong',
  '.vision-lateness-duration',
  '.vision-lateness-list-section > .vision-section-heading > small',
  '.review-metric-value > strong',
  '.rating-bars > div > strong',
  '.rating-bars > div > small',
  '.guest-review-score > div > strong',
  '.guest-rating-row > strong',
  '.kanban-column > header > span:last-child',
  '.permission-count > strong',
  '.archive-stats strong',

  // Audited table roles: values, never row ordinals or document numbers.
  ':is(td, [role="cell"])[data-label="Сумма"]',
  ':is(td, [role="cell"])[data-label="Количество"]',
  ':is(td, [role="cell"])[data-label="Цена"]',
  ':is(td, [role="cell"])[data-label="Выручка"]',
  ':is(td, [role="cell"])[data-label="Остаток"]',
  ':is(td, [role="cell"])[data-label="Факт"]',
  ':is(td, [role="cell"])[data-label="План"]',
  ':is(td, [role="cell"])[data-label="Разница"]'
].join(',');

// Use closest() against this registry before registering a target. Do not
// exclude every button or aria-hidden ancestor: chart symbols and state chips
// intentionally expose a separate exact accessible label for their numbers.
export const EXCLUDED_NUMBER_SELECTOR = [
  '[data-number-animate="false"]',
  '[data-number-motion-skip]',
  'input', 'textarea', 'select', 'option', 'label',
  '[contenteditable]:not([contenteditable="false"])',
  'time', 'svg',
  '[role="tooltip"]',
  'output[aria-live]',
  '.line-tooltip',
  '.revenue-column-readout',
  '.daily-bar-readout',
  '.hourly-tooltip',
  '.dashboard-number-exact',
  '.dashboard-number-visual',
  '.revenue-money-part',
  '.checks-money-part',
  '.dishes-money-part',
  '.temperature-number-part',
  '.sr-only', '.dp-sr-only', '.visually-hidden',
  '.checks-sr-only', '.dishes-sr-only', '.temperature-grid-sr-only',
  '.operation-date', '.daily-bar-date', '.revenue-column-date', '.dp-task-date',
  '.dp-task-number', '.dish-rank', '.dish-mobile-rank', '.dishes-leader-rank',
  '.sh-line-number', '.invoice-number', '.document-number',
  '[data-label="Дата"]', '[data-label="Номер"]', '[data-label="№"]',
  '[data-label="ИНН"]', '[data-label="БИК"]', '[data-label="Код"]'
].join(',');
